module.exports = __webpack_public_path__ + "img/get-it-on-google-play.2447efd.png";